import { motion } from "framer-motion";
import { IMAGES } from "@/data";
import { Reveal, Eyebrow } from "./Reveal";

function FleetImage({ src, alt, label, sub, className }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative overflow-hidden border border-gold/10 ${className}`}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105 grayscale-[0.2] group-hover:grayscale-0"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
      <div className="absolute bottom-0 left-0 p-7">
        <div className="text-[10px] tracking-[0.4em] uppercase text-gold/80">{sub}</div>
        <div className="font-serif text-2xl lg:text-3xl text-cream mt-1">{label}</div>
      </div>
    </motion.div>
  );
}

export default function Fleet() {
  return (
    <section id="fleet" className="relative py-28 lg:py-40 bg-ink-2" data-testid="fleet">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-16">
          <Reveal><Eyebrow>The Fleet</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif font-light text-cream text-4xl sm:text-5xl lg:text-6xl">
              Equipment that <span className="italic text-gold">commands respect.</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 auto-rows-[240px] md:auto-rows-[300px]">
          <FleetImage
            src={IMAGES.heroTruck}
            alt="Tractor trailer"
            sub="Long Haul"
            label="Tractor Trailers"
            className="md:col-span-7 md:row-span-2"
          />
          <FleetImage
            src={IMAGES.sprinter}
            alt="Mercedes Sprinter van"
            sub="Agile Delivery"
            label="Sprinter Vans"
            className="md:col-span-5"
          />
          <FleetImage
            src={IMAGES.medical}
            alt="Medical transport"
            sub="Care in Motion"
            label="Medical Transport"
            className="md:col-span-5"
          />
        </div>
      </div>
    </section>
  );
}
